import {FetchHandler} from "../../../../infrastructure/handlers/fetch-handler";
import {NEW_SEARCH_WIDGET} from "../../new-search-widget.consts";
import type {NewSearchWidgetController} from "../../new-search-widget.controller";
import type {NewSearchWidgetState} from "../../models/new-search-widget.state";
import {CompetitionsDomainService} from "../../../../domain/competitions/services/competitions.domain-service";
import {COMPETITION_CATEGORY} from "../../../../core/app/consts";
import {CompetitionsRequestParams} from "../../../../domain/competitions/models/competitions.request-params";
import {CompetitionViewModel} from "../../../../domain/common/competition/models/competition-view-model";
import {NewSearchWidgetListModel} from "../../models/new-search-widget.list.model";
import {COMPONENT_STATES} from "../../../../core/consts";

export class NewSearchWidgetTopCompetitionsFetchHandler extends FetchHandler {
  controller: NewSearchWidgetController;
  state: NewSearchWidgetState;
  type = NEW_SEARCH_WIDGET.ACTION_TYPES.TOP_ENTITIES.fetchCompetitions;

  static injectables = [CompetitionsDomainService];

  onLoaded() {
    super.onLoaded();

    this.action();
  }

  get requestParams(): CompetitionsDomainService {
    const limit: Number = this.controller.device.isSmallView ? NEW_SEARCH_WIDGET.MAX_TOP_ENTITIES.mobile : NEW_SEARCH_WIDGET.MAX_TOP_ENTITIES.desktop;
    const requestParams: CompetitionsRequestParams = new CompetitionsRequestParams(null, null, COMPETITION_CATEGORY.top, limit);

    return requestParams;
  }

  async action() {
    const dataSource = await super.fetch();

    if(dataSource?.competitions?.length > 0) {
      const entities = dataSource?.competitions?.map(competition => new CompetitionViewModel(competition))
      this.state.updateCompetitionsListModel(new NewSearchWidgetListModel(NEW_SEARCH_WIDGET.LIST_ID.topCompetitions, entities, 'WEB_SEARCH_POPULAR_LEAGUES', this.controller.terms, this.controller.device.isSmallView, false, NEW_SEARCH_WIDGET.HIGHLIGHTED_LIST_INDEX.competitions));
    }
    this.store.setComponentState(COMPONENT_STATES.loaded);

  }
}
